import React from "react";

function Maintenance() {
    return <div>Please select a data type to maintain</div>;
}

export default Maintenance;